.link {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 4px 0 10px;
  border: 2px solid transparent;
  border-radius: var(--radius-control);
  color: var(--ink);
  text-decoration: none;
}

.link[aria-current='page'] {
  border-color: var(--ink);
  background: var(--accent-soft);
}

.name {
  font-size: 15px;
  font-weight: 600;
}
